import React from "react";
import SimpleDDL from "../../../modules/SimpleDDL";
import {mapToObjectDDL} from "../../common/mapper";

export const formGroup = {
    voucherId: {value: "", mandatory: true},
    voucherName: {value: "", mandatory: true},
    validityPeriod: {value: 0, mandatory: true},
    pricePoint: {value: 0, mandatory: true},
    voucherType: {value: "", mandatory: true},
    subVoucherType: {value: null},
    applicableJob: {value: null},
    discountUnit: {value: null},
    discountValue: {value: null},
    spesificJobPart: {value: null},
    availibilityVoucher: {value: "", mandatory: true},
    availibilityStartDate: {value: null},
    availibilityEndDate: {value: null},
    maxAvailibility: {value: null},
    voucherStatus: {value: "ACTIVE", mandatory: true},
    voucherPictureBase64: {value: "", mandatory: true},
    voucherPictureUrl: {value: ""},

};

export const defaultFilter = {
    master: {
        voucherName: null,
        voucherType: null,
        subVoucherType: null,
        spesificJob: null,
        spesificPart: null,
        availibility: null,
    },
    user: {},
}

export const getTableConfig = (tab) => {
    return tab === "master" ? tableConfig.master : tableConfig.user
};

const tableConfig = {
    master: [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const {page, rowsPerPage} = tableMeta.tableState;
                    const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                    return <>{rowNumber}</>;
                },
            },
        },
        {
            name: "voucherId",
            label: "Kode Voucher",
        },
        {
            name: "voucherName",
            label: "Nama Voucher",
        },
        {
            name: "validityPeriod",
            label: "Masa Berlaku",
        },
        {
            name: "pricePoint",
            label: "Harga",
            options: {
                customBodyRender: (val) => {
                    return <>{val + " Point"}</>
                }
            }
        },
        {
            name: "voucherType",
            label: "Jenis Voucher",
            options: {
                customBodyRender: (val) => {
                    return <>{val}</>
                }
            }
        },
        {
            name: "status",
            label: "Status",
            options: {
                customBodyRender: (value) => {
                    return value === "ACTIVE" ? "AKTIF" : "TIDAK AKTIF";
                }
            }
        },
    ],
    user: [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const {page, rowsPerPage} = tableMeta.tableState;
                    const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                    return <>{rowNumber}</>;
                },
            },
        },
        {
            name: "kodeVoucher",
            label: "Kode Voucher",
        },
        {
            name: "voucherName",
            label: "Nama Voucher",
        },
        {
            name: "memberId",
            label: "Member ID"
        },
        {
            name: "used",
            label: "Used",
            options: {
                customBodyRender: (val) => {
                    return val === true ? "Y" : "N";
                }
            }
        }
    ],
};

export const voucherType = [
    {
        label: "UNDIAN",
        value: "UNDIAN",
    },
    {
        label: "BENGKEL",
        value: "BENGKEL",
    },
];

export const voucherSubTypeOptions = [
    {
        label: "JOB",
        value: "JOB",
    },
    {
        label: "PART",
        value: "PART",
    },
];

export const availability = [
    {
        label: "TIMED",
        value: "TIMED",
    },
    {
        label: "LIMITED",
        value: "LIMITED",
    },
    {
        label: "UNLIMITED",
        value: "UNLIMITED",
    },
];

export const used = [
    {
        label: "Y",
        value: true,
    },
    {
        label: "N",
        value: false,
    },
];

export const satuan = [
    {
        label: "Persentase",
        value: "PERSENTASE",
    },
    {
        label: "Rupiah",
        value: "RUPIAH",
    },
];